import { useContext, useMemo } from 'react'
import { SeoItemsTransport } from '../../../transports/home-page-transport'
import { Container, GridContainer, SliderContainer } from './styles'
import { ScreenContext } from 'react-components'
import RegionColumn from './region-column'
import { EmblaCarousel } from '../embla-carousel'

interface Props {
    regions: SeoItemsTransport[]
    columns?: number
    keyPrefix: string
}

export const SeoRegionsGrid = ({ regions, columns = 4, keyPrefix }: Props) => {
    const { isTablet, isDesktop } = useContext(ScreenContext)

    const distributedRegionsByColumn = useMemo(() => {
        return regions.reduce(
            (columnsArray, item, index) => {
                const colIndex = index % columns
                return columnsArray.map((col, idx) => (idx === colIndex ? [...col, item] : col))
            },
            Array.from({ length: columns }, () => [] as SeoItemsTransport[]),
        )
    }, [regions, columns])

    return (
        <Container>
            {isDesktop ? (
                <GridContainer columns={columns}>
                    {distributedRegionsByColumn.map((regions, colIndex) => (
                        <RegionColumn key={`${keyPrefix}-col-${colIndex}`} regions={regions} />
                    ))}
                </GridContainer>
            ) : (
                <SliderContainer>
                    <EmblaCarousel
                        slides={distributedRegionsByColumn.map((regions, colIndex) => (
                            <RegionColumn key={`${keyPrefix}-col-${colIndex}`} regions={regions} />
                        ))}
                        visibleSlides={isTablet ? 2.5 : 1.1}
                        slidesToScroll={1}
                    />
                </SliderContainer>
            )}
        </Container>
    )
}
